import _defineProperty from './../../external_lib/@babel/runtime/helpers/esm/defineProperty.js';
import _objectSpread2 from './../../external_lib/@babel/runtime/helpers/esm/objectSpread2.js';
import _typeof from './../../external_lib/@babel/runtime/helpers/esm/typeof.js';
import murmur2 from '../../../../@emotion/hash/dist/hash.esm.js';
import canUseDom from '../../../../rc-util/es/Dom/canUseDom.js';
import '../../../../rc-util/es/Dom/dynamicCSS.js';
import { ATTR_MARK, ATTR_TOKEN } from '../StyleContext.js';
import '../theme/createTheme.js';
import Theme from '../theme/Theme.js';
import '../theme/ThemeCache.js';

// Create a cache for memo concat

var resultCache = new WeakMap();
var RESULT_VALUE = {};
function memoResult(callback, deps) {
  var current = resultCache;
  for (var i = 0; i < deps.length; i += 1) {
    var dep = deps[i];
    if (!current.has(dep)) {
      current.set(dep, new WeakMap());
    }
    current = current.get(dep);
  }
  if (!current.has(RESULT_VALUE)) {
    current.set(RESULT_VALUE, callback());
  }
  return current.get(RESULT_VALUE);
}

// Create a cache here to avoid always loop generate
var flattenTokenCache = new WeakMap();

/**
 * Flatten token to string, this will auto cache the result when token not change
 */
function flattenToken(token) {
  var hashed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var str = flattenTokenCache.get(token) || '';
  if (!str) {
    Object.keys(token).forEach(function (key) {
      var value = token[key];
      str += key;
      if (value instanceof Theme) {
        str += value.id;
      } else if (value && _typeof(value) === 'object') {
        str += flattenToken(value, hashed);
      } else {
        str += value;
      }
    });

    // https://github.com/ant-design/ant-design/issues/48386
    // Should hash the string to avoid style tag name too long
    if (hashed) {
      str = murmur2(str);
    }

    // Put in cache
    flattenTokenCache.set(token, str);
  }
  return str;
}

/**
 * Convert derivative token to key string
 */
function token2key(token, salt) {
  return murmur2("".concat(salt, "_").concat(flattenToken(token, true)));
}
var isClientSide = canUseDom();
function unit(num) {
  if (typeof num === 'number') {
    return "".concat(num, "px");
  }
  return num;
}
function toStyleStr(style, tokenKey, styleId) {
  var customizeAttrs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var plain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  if (plain) {
    return style;
  }
  var attrs = _objectSpread2(_objectSpread2({}, customizeAttrs), {}, _defineProperty(_defineProperty({}, ATTR_TOKEN, tokenKey), ATTR_MARK, styleId));
  var attrStr = Object.keys(attrs).map(function (attr) {
    var val = attrs[attr];
    return val ? "".concat(attr, "=\"").concat(val, "\"") : null;
  }).filter(function (v) {
    return v;
  }).join(' ');
  return "<style ".concat(attrStr, ">").concat(style, "</style>");
}
export { flattenToken, isClientSide, memoResult, toStyleStr, token2key, unit };
//# sourceMappingURL=index.js.map
